import { isYes, yesOrNotSelectValidation } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
} from 'libs/form';
import { YesOrNoSelectType } from 'types/yesOrNo';

export interface CompanyGlobalFinancialMonitoringPartTwoFormType {
  hasSourceOfFundsProcedures: YesOrNoSelectType;
  hasRelationshipsWithPEPProcedures: YesOrNoSelectType;
  hasAnonymousAccounts: YesOrNoSelectType;
  hasAnonymousAccountPreventionProcedures: YesOrNoSelectType;
  hasTransactionMonitoringProcedures: YesOrNoSelectType;
  hasAssetFreezingProcedures: YesOrNoSelectType;

  hasAMLTrainingProcedures: YesOrNoSelectType;
  amlTrainingDetails?: string;

  hasBranchesInNonFATFCountries: YesOrNoSelectType;
  nonFATFBranchesNamesAndLocations?: string;

  hasCorrespondentsInNonFATFCountries: YesOrNoSelectType;
  nonFATFCorrespondentsNames?: string;

  hasCorrespondentsInOffshoreZones: YesOrNoSelectType;
  offshoreCorrespondentsNames?: string;

  hasShellBankRelationships: YesOrNoSelectType;
  shellBanksNames?: string;

  hasShellBankPreventionProcedures: YesOrNoSelectType;
  hasCDDRequestComplianceProcedures: YesOrNoSelectType;

  creditRating?: string;
  subsidiariesNamesAndLocations?: string;
  keyPartnersNames?: string;
  foreignBranchesNamesAndLocations?: string;
  financialGroupInfo?: string;

  hasSanctionPolicyDocuments: YesOrNoSelectType;
  hasSanctionsMonitoringProcedures: YesOrNoSelectType;
  isUnderSanctionsOrControlledBySanctionedEntity: YesOrNoSelectType;
  isListedInSanctionLists: YesOrNoSelectType;
  isLinkedToSanctionedEntities: YesOrNoSelectType;
}

export const maxLengthTextField = 200;

export const getSchema =
  (): ObjectSchema<CompanyGlobalFinancialMonitoringPartTwoFormType> =>
    object({
      hasSourceOfFundsProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),

      hasRelationshipsWithPEPProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),
      hasAnonymousAccounts: yesOrNotSelectValidation.default(null).required(),
      hasAnonymousAccountPreventionProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),
      hasTransactionMonitoringProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),
      hasAssetFreezingProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),

      hasAMLTrainingProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),
      amlTrainingDetails: string().when('hasAMLTrainingProcedures', {
        is: isYes,
        then: (schema) => schema.required().max(maxLengthTextField),
      }),

      hasBranchesInNonFATFCountries: yesOrNotSelectValidation
        .default(null)
        .required(),
      nonFATFBranchesNamesAndLocations: string().when(
        'hasBranchesInNonFATFCountries',
        {
          is: isYes,
          then: (schema) => schema.required().max(maxLengthTextField),
        }
      ),

      hasCorrespondentsInNonFATFCountries: yesOrNotSelectValidation
        .default(null)
        .required(),
      nonFATFCorrespondentsNames: string().when(
        'hasCorrespondentsInNonFATFCountries',
        {
          is: isYes,
          then: (schema) => schema.required().max(maxLengthTextField),
        }
      ),

      hasCorrespondentsInOffshoreZones: yesOrNotSelectValidation
        .default(null)
        .required(),
      offshoreCorrespondentsNames: string().when(
        'hasCorrespondentsInOffshoreZones',
        {
          is: isYes,
          then: (schema) => schema.required().max(maxLengthTextField),
        }
      ),

      hasShellBankRelationships: yesOrNotSelectValidation
        .default(null)
        .required(),
      shellBanksNames: string().when('hasShellBankRelationships', {
        is: isYes,
        then: (schema) => schema.required().max(maxLengthTextField),
      }),

      hasShellBankPreventionProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),
      hasCDDRequestComplianceProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),

      creditRating: string().max(maxLengthTextField),
      subsidiariesNamesAndLocations: string().max(maxLengthTextField),
      keyPartnersNames: string().max(maxLengthTextField),
      foreignBranchesNamesAndLocations: string().max(maxLengthTextField),
      financialGroupInfo: string().max(maxLengthTextField),

      hasSanctionPolicyDocuments: yesOrNotSelectValidation
        .default(null)
        .required(),
      hasSanctionsMonitoringProcedures: yesOrNotSelectValidation
        .default(null)
        .required(),
      isUnderSanctionsOrControlledBySanctionedEntity: yesOrNotSelectValidation
        .default(null)
        .required(),
      isListedInSanctionLists: yesOrNotSelectValidation
        .default(null)
        .required(),
      isLinkedToSanctionedEntities: yesOrNotSelectValidation
        .default(null)
        .required(),
    });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<CompanyGlobalFinancialMonitoringPartTwoFormType>();

export type FormErrors =
  FormErrorsBase<CompanyGlobalFinancialMonitoringPartTwoFormType>;
